import { Component, ChangeDetectionStrategy } from '@angular/core';
import { AgRendererComponent } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'wilson-date-renderer',
  template: `
    <div>
      <div>
        {{
          cellValue && !cellValue.includes('2099')
            ? (cellValue | date: 'dd.MM.yyyy')
            : ('page.qualifications.infinitely_valid' | translate)
        }}
      </div>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class DateRendererComponent implements AgRendererComponent {
  public cellValue!: string;

  agInit(params: ICellRendererParams): void {
    this.cellValue = this.getValueToDisplay(params);
  }

  refresh(params: ICellRendererParams) {
    this.cellValue = this.getValueToDisplay(params);
    return true;
  }

  getValueToDisplay(params: ICellRendererParams) {
    return params.value;
  }
}
